/* eslint-disable react-hooks/rules-of-hooks */
import React, { Fragment, useState } from 'react';
import { Grid, Typography, Button, TextField } from '@mui/material';
import EmployeeCard from './EmployeeCard';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import {
  approveLieuLeave,
  rejectLieuLeave,
  approveLeave,
  rejectLeave,
  approveCancelLeave,
  rejectCancelLeave
} from 'src/services/leaveService';
import { useDispatch, useSelector } from 'react-redux';
import { AppActions } from 'src/store/AppReducer';
import { useAppSelector } from 'src/hooks/hooks';
import ConfirmationModal from '../common/confirmationModal/ConfirmationModal';
import { RootStateType } from 'src/store/RootReducer';
import moment from 'moment';
import { useNavigate } from 'react-router';
import { Theme } from '@fullcalendar/react';
import './LeaveManagement.css';
import {
  getCancelReason,
  getEmploymentType,
  isCancellationRequest
} from './utils/cancellationUtils';

interface Props {
  onView: (data: any) => void;
  leaveDetails?: any;
  isApproved?: any;
  tabValue?: string;
}

const LeaveCard = (props) => {
  const nameStyle = {
    fontSize: '13px',
    color: '#1e2a3b',
    fontWeight: 700,
    lineHeight: 1.3
  };

  const textStyle = {
    fontSize: '12px',
    color: '#8b95a7',
    fontWeight: 400,
    lineHeight: 1.4
  };

  const imageStyle = {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    backgroundColor: 'grey'
  };

  const wrapper = {
    backgroundColor: 'transparent',
    marginLeft: '0px',
    marginRight: '0px',
    padding: '0 14px',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    boxSizing: 'border-box'
  };

  const dateWrapper = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end'
  };

  const leaveAvailablewrapper = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  };

  const overlay = {
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    position: 'absolute',
    backgroundColor: 'rgba(0,0,0,0.5)',
    borderRadius: '3px',
    display: 'flex',
    alignItems: 'flex-end'
  };

  const LabelStyle = {
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '11px'
  };

  const TextFieldStyle = {
    paddingTop: 4,
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '11px'
  };

  const errorStyle = {
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '11px',
    color: 'red'
  };

  const reasonWrapper = {
    backgroundColor: 'white',
    paddingTop: '12px',
    paddingBottom: '12px',
    borderRadius: '3px',
    margin: '2px'
  };

  const rejectBtnStyle = {
    height: '1.75rem',
    backgroundColor: '#F8F2F2',
    color: 'red',
    width: '100%'
  };

  const rejectBtnDisableStyle = {
    height: '1.75rem',
    backgroundColor: '#F8F2F2',
    color: 'red',
    width: '100%',
    opacity: 0.4
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loggedUserName = useSelector(
    (state: RootStateType) => state.appReducer.user.Name
  );
  const { isLoading } = useAppSelector((state) => state.appReducer);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [rejectComfirmation, setRejectComfirmation] = useState(false);

  const [showReason, setShowReason] = useState(false);
  const [rejectReason, setRejectReason] = useState('');
  const [isDisableReject, setIsDisableReject] = useState(true);

  const isCancelPending = isCancellationRequest(props.leaveDetails);
  const cancelReasonText = getCancelReason(props.leaveDetails);

  const sendData = (data) => {
    props.onDataChange(data);
  };

  //approve lieu leave request
  const onApproveLieuLeave = (requestId, employmentType) => {
    dispatch(AppActions.showLoader());
    approveLieuLeave(requestId, (employmentType || '').toUpperCase())
      .then((res) => {
        dispatch(
          AppActions.toggleSnackBarOpen({
            message: `You have approved the eligibility request successfully.`,
            severity: 'success'
          })
        );
        setOpenConfirmation(false);
        sendData(true);
        dispatch(AppActions.hideLoader());
      })
      .catch((e) => {
        dispatch(
          AppActions.toggleSnackBarOpen({
            message: e?.response?.data?.message ? e?.response?.data?.message : 'Unable to approve leave.',
            severity: 'error'
          })
        );
        setOpenConfirmation(false);
        dispatch(AppActions.hideLoader());
      });
  };

  //approve pending leave , RM approved request, work from home, and cancellation request
  const onApproveLeave = (requestId, employmentType) => {
    dispatch(AppActions.showLoader());
    const isCancellationPending = isCancellationRequest(props.leaveDetails);
    const empType = (employmentType || getEmploymentType(props.leaveDetails) || '').toUpperCase();
    const approveCall = isCancellationPending
      ? approveCancelLeave(requestId, empType, loggedUserName)
      : approveLeave(requestId, empType, loggedUserName);
    approveCall
      .then((res) => {
        dispatch(
          AppActions.toggleSnackBarOpen({
            message: isCancellationPending
              ? 'You have approved the cancellation successfully.'
              : props.tabValue === 'one'
            ? props.leaveDetails?.typeName === "Work From Home" 
            ? `You have approved the work from home request successfully.`
            : `You have approved the leave successfully.`
            : `You have approved the RM approved request successfully.`,
            severity: 'success'
          })
        );
        setOpenConfirmation(false);
        sendData(true);
        dispatch(AppActions.hideLoader());
        dispatch(AppActions.triggerFunction({isTrigger: true}));
      })
      .catch((e) => {
        dispatch(
          AppActions.toggleSnackBarOpen({
            message: e?.response?.data?.message ? e?.response?.data?.message : 'Unable to approve leave.',
            severity: 'error'
          })
        );
        setOpenConfirmation(false);
        dispatch(AppActions.hideLoader());
      });
  }

  //reject lieu leave request
  const onRejectLieuLeave = (requestId, rejectReason) => {
    dispatch(AppActions.showLoader());
    const data = {
      rejectReason: rejectReason
    };
    const employmentType = (getEmploymentType(props.leaveDetails) || '').toUpperCase();
    rejectLieuLeave(
      requestId,
      data,
      employmentType
    )
      .then((res) => {
        dispatch(
          AppActions.toggleSnackBarOpen({
            message: res.data.message,
            severity: 'success'
          })
        );
        setRejectComfirmation(false);
        sendData(true);
        setShowReason(false)
        dispatch(AppActions.hideLoader());
      })
      .catch((e) => {
        dispatch(
          AppActions.toggleSnackBarOpen({
            message: e.response?.data?.message ? e.response?.data?.message : 'Unable to reject leave.',
            severity: 'error'
          })
        );
        setRejectComfirmation(false);
        setShowReason(false)
        dispatch(AppActions.hideLoader());
      });
  };

  //reject pending leave , RM approved request, work from home, and cancellation request
  const onRejectLeave = (requestId, rejectReason) => {
    dispatch(AppActions.showLoader());
    const data = {
      rejectReason: rejectReason
    };
    const isCancellationPending = isCancellationRequest(props.leaveDetails);
    const empType = (getEmploymentType(props.leaveDetails) || '').toUpperCase();
    const rejectCall = isCancellationPending
      ? rejectCancelLeave(
          requestId,
          data,
          loggedUserName,
          empType
        )
      : rejectLeave(
          requestId,
          data,
          loggedUserName,
          empType
        );
    rejectCall
      .then((res) => {
        dispatch(
          AppActions.toggleSnackBarOpen({
            message: isCancellationPending
              ? 'You have rejected the cancellation successfully.'
              : props.leaveDetails?.typeName === "Work From Home" 
              ? `You have rejected the work from home request successfully.`
              : `You have rejected the leave successfully.`,
            severity: 'success'
          })
        );
        setRejectComfirmation(false);
        sendData(true);
        setShowReason(false)
        dispatch(AppActions.hideLoader());
      })
      .catch((e) => {
        dispatch(
          AppActions.toggleSnackBarOpen({
            message: e.response?.data?.message ? e.response?.data?.message : 'Unable to reject leave.',
            severity: 'error'
          })
        );
        setRejectComfirmation(false);
        setShowReason(false)
        dispatch(AppActions.hideLoader());
      });
  };

  const validateComfirmation = () => {
    setOpenConfirmation(!openConfirmation);
  };

  const validateReason = () => {
    setRejectComfirmation(!rejectComfirmation);
  };

  const reasonText = isCancelPending
    ? cancelReasonText || props.leaveDetails?.leaveReason
    : props.leaveDetails?.leaveReason;

  return (
    <Fragment>
      <Grid
        xs={6}
        container
        display={'flex'}
        flexDirection={'column'}
        alignItems={'stretch'}
        className={
          isCancelPending ? 'leave-card leave-card-cancel-pending' : 'leave-card'
        }
        style={{
          padding: '0 0 14px',
          margin: '6px',
          flexBasis: '32%',
          position: 'relative',
          overflow: 'hidden',
          boxSizing: 'border-box',
          gap: '14px'
        }}
      >
        <Grid
          className={
            isCancelPending
              ? 'leave-card-header leave-card-cancel-header'
              : 'leave-card-header'
          }
          style={{ width: '100%' }}
        >
          <EmployeeCard
            data={props?.leaveDetails}
            isCancellationRequest={isCancelPending}
          />
        </Grid>
        <Grid sx={wrapper}>
          <Grid sx={dateWrapper} style={{ alignItems: 'flex-start' }}>
            <Grid>
              <Typography style={nameStyle} variant="h5">
                {props.leaveDetails?.isEligible
                  ? 'Lieu Leave Eligibility'
                  : props.leaveDetails?.typeName}
              </Typography>
              <Typography style={textStyle} variant="h6">
                {props.tabValue === 'two'
                  ? 'Extra Worked day/s: '
                  : props.leaveDetails?.fromDate === props.leaveDetails?.toDate
                  ? 'On: ' + props.leaveDetails?.fromDate
                  : props.leaveDetails?.fromDate +
                    ' - ' +
                    props.leaveDetails?.toDate}
              </Typography>
              {props.tabValue === 'two' && (
                <Typography
                  style={{
                    fontSize: '12px',
                    color: '#8b95a7',
                    fontWeight: 400,
                    marginTop: 2
                  }}
                  variant="h6"
                >
                  {props.leaveDetails?.fromDate === props.leaveDetails?.toDate
                    ? moment(props.leaveDetails?.fromDate).format('D MMM YYYY')
                    : moment(props.leaveDetails?.fromDate).format('D MMM YYYY') +
                      ' - ' +
                      moment(props.leaveDetails?.toDate).format('D MMM YYYY')}
                </Typography>
              )}
            </Grid>
            <Grid>
              <Typography
                style={{ ...textStyle, color: '#6b7280', whiteSpace: 'nowrap' }}
                variant="h6"
              >
                {props.leaveDetails?.numberOfDays}{' '}
                {props.leaveDetails?.numberOfDays < 2 ? 'Day' : 'Days'}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid sx={wrapper} style={{ minHeight: '3.25rem' }}>
          {props.tabValue === 'two' && (
            <div
              style={{ display: 'flex', marginTop: '4px', marginBottom: '4px' }}
            >
              <Typography
                style={{
                  fontSize: '10px',
                  fontWeight: 'bold',
                  marginRight: '4px'
                }}
              >
                Project :
              </Typography>
              <Typography style={textStyle} fontWeight="light" variant="h6">
                {props.leaveDetails?.projectName
                  ? props.leaveDetails?.projectName
                  : '---'}
              </Typography>
            </div>
          )}
          {props.tabValue === 'two' && (
            <div style={{ display: 'flex', marginBottom: '4px' }}>
              <Typography
                style={{
                  fontSize: '10px',
                  fontWeight: 'bold',
                  marginRight: '4px'
                }}
              >
                Project Lead :
              </Typography>
              <Typography style={textStyle} fontWeight="light" variant="h6">
                {props.leaveDetails?.projectLeadName
                  ? props.leaveDetails?.projectLeadName
                  : '---'}
              </Typography>
            </div>
          )}
          <Typography
            style={{
              fontSize: '13px',
              color: '#6b7280',
              fontWeight: 400,
              wordWrap: 'break-word',
              width: '100%',
              maxHeight: '4.5rem',
              overflow: 'auto',
              lineHeight: 1.45
            }}
            variant="h6"
            className="scroll-bar-width"
          >
            {reasonText}
          </Typography>
        </Grid>
        <Grid sx={wrapper}>
          <Grid
            sx={{
              display: 'flex',
              justifyContent:
                props.tabValue !== 'two' &&
                props.leaveDetails?.typeName !== 'Work From Home' &&
                props.leaveDetails?.typeName !== 'No Pay Leave'
                  ? 'space-between'
                  : 'flex-end',
              alignItems: 'center'
            }}
          >

            {props.tabValue !== 'two' &&
              props.leaveDetails?.typeName !== 'Work From Home' &&
              props.leaveDetails?.typeName !== 'No Pay Leave' && (
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  height: '32px',
                  padding: '0 10px',
                  borderRadius: '8px',
                  backgroundColor: '#e7f6ee',
                  color: '#1e2a3b',
                  fontSize: '12px',
                  fontWeight: 500
                }}
              >
                <span style={{ color: '#2eaf70', marginRight: '5px', fontWeight: 700 }}>
                  {props.leaveDetails?.balance ? props.leaveDetails.balance : '0'}
                </span>
                Leaves Available
              </span>
            )}
            <VisibilityOutlinedIcon
              style={{
                fontSize: '18px',
                cursor: 'pointer',
                color: '#98a2b3'
              }}
              onClick={() => {
                props.tabValue === 'one'
                  ? navigate(
                      `/leave-management/leave-view/${props?.leaveDetails?.id}?name=pending`
                    )
                  : props.tabValue === 'two'
                  ? navigate(
                      `/leave-management/leave-view/${props?.leaveDetails?.id}?name=lieuLeave`
                    )
                  : navigate(
                      `/leave-management/leave-view/${props?.leaveDetails?.id}?name=rmApproved`
                    );
              }}
            />
          </Grid>
        </Grid>
        <Grid sx={wrapper}>
          <Grid sx={leaveAvailablewrapper} style={{ gap: '10px' }}>
            <Button
              className={
                isCancelPending ? 'leave-card-cancel-approve' : undefined
              }
              disableElevation
              sx={{
                fontSize: '13px',
                fontWeight: 600,
                textTransform: 'none',
                borderRadius: '8px',
                backgroundColor: isCancelPending ? '#c4842a' : '#5569ff',
                boxShadow: 'none',
                '&:hover': {
                  backgroundColor: isCancelPending ? '#b07322' : '#4457e6',
                  boxShadow: 'none'
                }
              }}
              variant="contained"
              style={{
                height: '36px',
                width: '100%'
              }}
              onClick={() => validateComfirmation()}
            >
              Approve
            </Button>
            <Button
              disableElevation
              sx={{
                fontSize: '13px',
                fontWeight: 600,
                textTransform: 'none',
                borderRadius: '8px',
                backgroundColor: '#fdecec',
                color: '#e24b4b',
                boxShadow: 'none',
                '&:hover': {
                  backgroundColor: '#fdecec',
                  boxShadow: 'none'
                }
              }}
              variant="contained"
              style={{
                height: '36px',
                width: '100%'
              }}
              onClick={() => setShowReason(true)}
            >
              Reject
            </Button>
          </Grid>
        </Grid>
        {showReason && (
          <Grid sx={overlay}>
            <Grid item xs={12} sx={reasonWrapper}>
              <Typography style={LabelStyle} fontWeight="light" variant="h5">
                Reject Reason <span style={{ color: 'red' }}>*</span>
              </Typography>
              <TextField
                size="small"
                multiline
                rows={3}
                className="input-text"
                style={TextFieldStyle}
                InputProps={{
                  inputProps: {
                    style: {
                      fontSize: '11px'
                    },
                    maxLength: 200
                  }
                }}
                fullWidth
                placeholder="Enter reject reason"
                variant="outlined"
                onChange={(event) => {
                  setRejectReason(event.target.value);

                  if (event.target.value.trim()) {
                    setIsDisableReject(false);
                  } else {
                    setIsDisableReject(true);
                  }
                }}
              />
              <Typography style={errorStyle}></Typography>
              <Grid
                sx={leaveAvailablewrapper}
                style={{
                  paddingTop: '10px',
                  paddingRight: '10px',
                  paddingLeft: '10px'
                }}
              >
                <Button
                  sx={{
                    mr: 1,
                    mt: { xs: 2, md: 0 },
                    fontSize: '11px',
                    fontWeight: 'normal',
                    background: '#F5F7FF',
                    color: '#5569ff'
                  }}
                  variant="contained"
                  style={{ height: '1.75rem', width: '100%' }}
                  onClick={(e) => setShowReason(false)}
                >
                  Cancel
                </Button>
                <Button
                  sx={{
                    ml: 1,
                    mt: { xs: 2, md: 0 },
                    fontSize: '11px',
                    fontWeight: 'normal'
                  }}
                  disabled={isDisableReject}
                  variant="contained"
                  style={
                    isDisableReject ? rejectBtnDisableStyle : rejectBtnStyle
                  }
                  onClick={validateReason}
                >
                  Reject
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
      <ConfirmationModal
        isLoading={isLoading}
        open={openConfirmation}
        toggle={validateComfirmation}
        message={
          isCancelPending
            ? `Are you sure you want to approve this cancellation request?`
            : props.tabValue === 'two'
            ? `Are you sure you want to approve this eligibility request?`
            : props.tabValue === 'one'
            ? props.leaveDetails?.typeName === "Work From Home" 
            ? `Are you sure you want to approve this work from home request?` 
            : `Are you sure you want to approve this leave?`
            : `Are you sure you want to approve this PM/RM approved request?`
        }
        onConfirm={() => {
          // Cancellation requests always use cancel approve endpoint
          if (isCancelPending) {
            onApproveLeave(
              props?.leaveDetails?.id,
              getEmploymentType(props.leaveDetails)
            );
          } else if (props.tabValue === 'two') {
            onApproveLieuLeave(
              props?.leaveDetails?.id,
              getEmploymentType(props.leaveDetails)
            );
          } else {
            onApproveLeave(
              props?.leaveDetails?.id,
              getEmploymentType(props.leaveDetails)
            );
          }
        }}
        noToggle={validateComfirmation}
      />
      <ConfirmationModal
        isLoading={isLoading}
        open={rejectComfirmation}
        toggle={validateReason}
        message={
          isCancelPending
            ? `Are you sure you want to reject this cancellation request?`
            : props.tabValue === 'two'
            ? `Are you sure you want to reject this eligibility request?`
            : props.tabValue === 'one'
            ? props.leaveDetails?.typeName === "Work From Home" 
            ? `Are you sure you want to reject this work from home request?` 
            : `Are you sure you want to reject this leave?`
            : `Are you sure you want to reject this PM/RM approved request?`
        }
        onConfirm={() => {
          if (isCancelPending) {
            onRejectLeave(props?.leaveDetails?.id, rejectReason);
          } else if (props.tabValue === 'two') {
            onRejectLieuLeave(props?.leaveDetails?.id, rejectReason);
          } else {
            onRejectLeave(props?.leaveDetails?.id, rejectReason);
          }
        }}
        noToggle={validateReason}
      />
    </Fragment>
  );
};

export default LeaveCard;
